import React from 'react';

function BlogSection() {
  const scrollRef = React.useRef(null);
  const autoIntervalRef = React.useRef(null);
  const step = 464;

  const scroll = function (dir) {
    if (scrollRef.current) {
      var el = scrollRef.current;
      if (dir > 0 && el.scrollLeft + el.clientWidth >= el.scrollWidth - 10) {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && el.scrollLeft <= 10) {
        el.scrollTo({ left: el.scrollWidth, behavior: 'smooth' });
      } else {
        el.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
    }
  };

  React.useEffect(function () {
    autoIntervalRef.current = setInterval(function () {
      if (scrollRef.current) {
        var el = scrollRef.current;
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 10) {
          el.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          el.scrollBy({ left: step, behavior: 'smooth' });
        }
      }
    }, 4000);
    return function () {
      if (autoIntervalRef.current) clearInterval(autoIntervalRef.current);
    };
  }, []);

  const styles = {
    section: {
      width: '100%', maxWidth: 1920, minHeight: 680, margin: '0 auto', background: '#FFFFFF', opacity: 1,
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: '80px 48px 48px', boxSizing: 'border-box'
    },
    subheading: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '22px', lineHeight: '100%',
      letterSpacing: '-0.01em', textAlign: 'center', textTransform: 'uppercase',
      color: '#090909', margin: 0
    },
    dashLine: {
      width: 120, height: 0, borderTop: '2px solid #E73123', opacity: 1, flexShrink: 0
    },
    headerRow: {
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
      marginBottom: 24
    },
    titleWrap: { marginBottom: 32, textAlign: 'center', width: '100%' },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '32px', lineHeight: '100%',
      letterSpacing: 0, textAlign: 'center', textTransform: 'uppercase',
      color: '#E73123', display: 'inline'
    },
    titleDark: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '32px', lineHeight: '100%',
      letterSpacing: 0, textAlign: 'center', textTransform: 'uppercase',
      color: '#090909', display: 'inline'
    },
    cardsRow: {
      display: 'flex', gap: 24, overflowX: 'auto', width: '100%', maxWidth: 1100,
      paddingBottom: 16, scrollSnapType: 'x mandatory', scrollbarWidth: 'none', msOverflowStyle: 'none'
    },
    card: {
      flexShrink: 0, width: 460, background: '#FFFFFF', overflow: 'visible',
      textAlign: 'center', boxSizing: 'border-box', display: 'flex', flexDirection: 'column',
      boxShadow: '0 8px 30px rgba(0,0,0,0.12)', scrollSnapAlign: 'start',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease', cursor: 'pointer'
    },
    cardImgWrap: { position: 'relative', width: '100%', flexShrink: 0, overflow: 'hidden', padding: 0, margin: 0, lineHeight: 0 },
    cardImg: { width: '100%', height: 286, objectFit: 'cover', objectPosition: 'center center', display: 'block', opacity: 1, verticalAlign: 'top' },
    cardContent: { padding: '20px 14px', flex: 1, textAlign: 'center' },
    cardTitle: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '19px', lineHeight: '1.4',
      letterSpacing: 0, textTransform: 'uppercase', color: '#090909', margin: '0 0 10px 0'
    },
    cardDesc: {
      fontFamily: 'Lato', fontWeight: 400, fontStyle: 'normal', fontSize: 15,
      lineHeight: '26px', letterSpacing: 0, color: '#838383', margin: 0
    },
    navWrap: { display: 'flex', gap: 12, justifyContent: 'center', marginTop: 24 },
    navBtn: {
      width: 48, height: 48, borderRadius: 8, border: 'none', background: '#E73123', color: '#fff',
      cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'opacity 0.2s'
    }
  };

  const cards = [
    {
      img: '/moderninfrastructure.png',
      titleLines: ['THE IMPORTANCE OF STRONG FOUNDATIONS', 'IN MODERN INFRASTRUCTURE'],
      descLines: [
        'Understanding how precision piling ensures structural stability,',
        'safety, and long-term durability in large-scale developments.'
      ]
    },
    {
      img: '/advancedpipeline.png',
      titleLines: ['ADVANCED PILING TECHNIQUES', 'TRANSFORMING CONSTRUCTION'],
      descLines: [
        'A look at modern equipment and innovative methods improving',
        'efficiency and performance on complex sites.'
      ]
    },
    {
      img: '/highspeedrail.png',
      titleLines: ['ROLE OF HIGH SPEED RAIL', 'IN NATIONAL DEVELOPMENT'],
      descLines: [
        'Exploring how deep transportation networks connect regions',
        'and drive economic growth across the nation.'
      ]
    },
    {
      img: '/precast.png',
      titleLines: ['PRECAST VS CAST-IN-SITU PILING:', 'CHOOSING THE RIGHT SOLUTION'],
      descLines: [
        'Comparing techniques to determine the most effective approach',
        'based on soil conditions and project demands.'
      ]
    }
  ];

  return React.createElement(React.Fragment, null,
    React.createElement('style', null,
      '.blog-card:hover { transform: translateY(-4px); box-shadow: 0 12px 36px rgba(0,0,0,0.15); }' +
      '.blog-cards::-webkit-scrollbar { display: none; }'
    ),
    React.createElement('section', { style: styles.section },
      React.createElement('div', { style: styles.headerRow },
        React.createElement('div', { style: styles.dashLine }),
        React.createElement('h2', { style: styles.subheading }, 'OUR BLOG'),
        React.createElement('div', { style: styles.dashLine })
      ),
      React.createElement('div', { style: styles.titleWrap },
        React.createElement('span', { style: styles.titleRed }, 'INSIGHTS, INNOVATIONS, '),
        React.createElement('span', { style: styles.titleDark }, 'AND INDUSTRY PERSPECTIVES')
      ),
      React.createElement('div', { ref: scrollRef, className: 'blog-cards', style: styles.cardsRow },
        cards.map(function (c, i) {
          return React.createElement('div', { key: i, className: 'blog-card', style: styles.card },
            React.createElement('div', { style: styles.cardImgWrap },
              React.createElement('img', { src: c.img, alt: '', style: styles.cardImg })
            ),
            React.createElement('div', { style: styles.cardContent },
              React.createElement('h3', { style: styles.cardTitle },
                c.titleLines.map(function (line, j) {
                  return React.createElement('div', { key: j }, line);
                })
              ),
              React.createElement('div', { style: styles.cardDesc },
                c.descLines.map(function (line, k) {
                  return React.createElement('div', { key: k }, line);
                })
              )
            )
          );
        })
      ),
      React.createElement('div', { style: styles.navWrap },
        React.createElement('button', { type: 'button', style: styles.navBtn, onClick: function () { scroll(-1); } },
          React.createElement('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: '#fff', strokeWidth: 2 },
            React.createElement('path', { d: 'M15 18l-6-6 6-6' })
          )
        ),
        React.createElement('button', { type: 'button', style: styles.navBtn, onClick: function () { scroll(1); } },
          React.createElement('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: '#fff', strokeWidth: 2 },
            React.createElement('path', { d: 'M9 18l6-6-6-6' })
          )
        )
      )
    )
  );
}

export default BlogSection;
